var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"page-loader"},[_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }